import useUIBp from "../../../Hooks/useUIBoilerplate";
import deleteDevices from "../../../store/actions/devices/deleteDevices";
import DeleteConfirmation from "./Deletions/DeleteConfirmation";

const DeleteDevicesConfirmation = () => {
  const { auth,dispatch, settings, UI } = useUIBp();
  const locale = settings.locale;
  const { payload } = UI.modal2;
  const { devices } = payload;

  const confirmation = () => {
    dispatch(deleteDevices({
      ...auth,
      devices,
      locale,
    }))
  };

  return <DeleteConfirmation {...{ confirmation }} />;
};

export default DeleteDevicesConfirmation;
